import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  UkIndustryEcommerceIcon,
  UkTaxiBookingIcon,
} from "../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Industryukapp() {
  return (
    <section className="industry_uk_app p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              On-Board Value-Driven Mobile App Development Company in Dubai
            </h2>
            <p>
              Being the most reliable custom app development company in Dubai,
              UAE, we take 100% ownership of every project we work on. Our
              diverse team of business analysts, project managers, interface
              designers, and core app developers in Dubai help your build
              user-centric, scalable mobile applications that is further
              polished by quality testers for flawless functioning. Further our
              product technologies and growth strategist offer continuous
              support to expand and upscale the functionalities and offerings to
              win over more and more Android and Apple users across UAE.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="industy_uk_main">
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  {UkIndustryEcommerceIcon}
                </div>
                <div className="industry_uk_content">
                  <h5>E-commerce</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">{UkTaxiBookingIcon}</div>
                <div className="industry_uk_content">
                  <h5>Taxi Booking</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/tourism.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Tourism</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/healthcare.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Healthcare </h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/retail.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Retail</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/real_estate.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Real Estate</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/metaverse.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Metaverse</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/oil.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Oil & Gas</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/banking.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Banking</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/manufacturing.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Manufacturing</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/Logistics.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>Logistics</h5>
                </div>
              </div>
              <div className="industy_uk_item">
                <div className="industry_uk_icon">
                  <StaticImage
                    src="../../images/location_new/uk-mobile/industry_icons/finTech.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={89}
                  />
                </div>
                <div className="industry_uk_content">
                  <h5>FinTech</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Industry Specific App Development
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Industryukapp;
